export default __webpack_public_path__ + "static/media/Chinmaya Kumar Rout - Secretary, NIBA Alumni Assocation.f627cbff.jpg";